// features/flights/flightSlice.js

import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getFlightContentList } from '../../services/flight/flightServices';

export const fetchFlightContent = createAsyncThunk(
    'flights/fetchFlightContent',
    async ({ fromCode, toCode }, { rejectWithValue }) => {
        try {
            const data = await getFlightContentList(fromCode, toCode);
            return data;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);


const flightSlice = createSlice({
    name: 'flights',
    initialState: {
        content: [],
        isLoading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchFlightContent.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(fetchFlightContent.fulfilled, (state, action) => {
                state.isLoading = false;
                state.content = action.payload.data || [];
            })
            .addCase(fetchFlightContent.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload || 'Failed to fetch flight content';
            });
    },
});

export default flightSlice.reducer;
